import React, { createContext, FC } from 'react';
import { useProfile } from '../hooks/useProfile';
import { Profile } from '../models/Profile';

interface MainContextProps {
  profile?: Profile;
  fetchProfile: () => Promise<Profile>;
}

export const MainContext = createContext<MainContextProps | null>(null);

interface Props {
  children?: React.ReactNode;
}

export const MainContextProvider: FC<Props> = ({ children }) => {
  const { fetchProfile, profile } = useProfile();

  return (
    <MainContext.Provider value={{
      profile,
      fetchProfile,
    }}
    >
      {children}
    </MainContext.Provider>
  );
};

export const useMainContext = () => {
  const context = React.useContext(MainContext);
  if (context === null) {
    throw new Error('useMainContext must be used within a MainContextProvider');
  }
  return context;
};
